import groupSelection from "./rw/rw_groupSelection";
import memberLayout from "./rw/memberLayout";
import menu from "./rw/menu";
import adminLayout from "./rw/adminLayout";
import noGroup from "./rw/noGroup";
import memberDashboard from "./rw/memberDashboard";
export default {
  groupSelection,
  memberLayout,
  menu,
  adminLayout,
  noGroup,
  memberDashboard,
  auth: {
    signIn: "Injira",
    signInHelp: "Andika imeyili wandikishije kugira ngo wohererezwe kode yo kwemeza.",
    email: "Imeyili",
    emailPlaceholder: "izina{'@'}example.com",
    sendCode: "Ohereza kode",
    verificationCode: "Kode yo kwemeza",
    verifyAndLogin: "Emeza maze winjire",
    backHome: "Subira ahabanza",
    brandDescription: "Urubuga rwizewe kandi rugezweho rwo gucunga kwizigamira mu matsinda, inguzanyo n’imicungire myiza y’imari.",
    featureSecure: "Kwinjira mu buryo bwizewe ukoresheje imeyili",
    featureTracking: "Kurikirana imisanzu n’inguzanyo",
    featureMembers: "Gucunga abanyamuryango mu mucyo",
    codeSent: "Niba imeyili ibaho, kode yo kwemeza yoherejwe.",
    sendCodeFailed: "Kohereza kode yo kwemeza byanze.",
    verificationFailed: "Kwemeza kode byanze.",
    rightsReserved: "Uburenganzira bwose burabitswe.",
  },
  "home": {
    "nav": {
      "about": "Ibyerekeye",
      "features": "Ibirangamimerere",
      "howItWorks": "Uko Ikora",
      "faq": "Ibibazo Bikunze Kubazwa",
      "toggleTheme": "Hindura ibara rya sisitemu",
      "login": "Injira",
      "requestDemo": "Saba Kwerekwa Sisitemu"
    },
    "hero": {
      "chip": "Imicungire igezweho yo kwizigamira no gutanga inguzanyo",
      "title": "Kurikirana Imisanzu, Cunga Inguzanyo kandi Mutere Imbere Mwizeye",
      "description": "Urubuga rw’umwuga rufasha amatsinda yo kwizigamira, amakoperative, amashyirahamwe n’imiryango gucunga imisanzu, inguzanyo, inyungu, ibihano, abanyamuryango na raporo ahantu hamwe hizewe.",
      "requestDemo": "Saba Kwerekwa",
      "exploreFeatures": "Reba Ibiranga Sisitemu",
      "badges": {
        "transparent": "Inyandiko Zisobanutse",
        "secure": "Kwinjira Mu Mutekano",
        "reports": "Raporo Zifasha"
      }
    },
    "dashboard": {
      "highlights": "Iby’ingenzi muri Sisitemu",
      "liveOverview": "Incamake y’ako kanya",
      "stats": {
        "contributions": "Imisanzu Yose",
        "loans": "Inguzanyo Zikiriho",
        "profit": "Inyungu",
        "penalties": "Ibihano"
      }
    },
    "trust": {
      "memberManagement": "Gucunga Abanyamuryango",
      "loanTracking": "Gukurikirana Inguzanyo",
      "penaltyControl": "Gucunga Ibihano",
      "reportsInsights": "Raporo n’Isesengura"
    },
    "partners": {
      "title": "Yagenewe Imiryango Ishaka Gutera Imbere",
      "subtitle": "Ikwiriye amatsinda y’imari n’ibigo bikeneye gahunda, gukorera mu mucyo no gutera imbere.",
      "items": [
        "Amatsinda yo Kwizigamira",
        "Amakoperative",
        "Amashyirahamwe y’Abaturage",
        "Amatsinda y’Abagore",
        "Amatsinda y’Urubyiruko",
        "Amatsinda Ashingiye ku Iyobokamana"
      ]
    },
    "about": {
      "title": "Ibyerekeye Urubuga",
      "paragraph1": "Uru rubuga rwo gucunga ubwizigame n’inguzanyo rufasha imiryango gukoresha ikoranabuhanga mu micungire y’imari no gucunga ibikorwa by’abanyamuryango mu buryo bwizewe.",
      "paragraph2": "Kuva ku misanzu n’ishyurwa ry’inguzanyo kugeza ku kugabana inyungu, ibihano na raporo, sisitemu ihuriza hamwe ibikorwa by’ingenzi bifasha kunoza imicungire, gukorera mu mucyo no gukora neza.",
      "quickStats": [
        {
          "title": "Itekanye",
          "text": "Inyandiko zirinzwe kandi kwinjira kugenzurwa"
        },
        {
          "title": "Ifite Ubwenge",
          "text": "Raporo n’isesengura bifasha gufata ibyemezo"
        },
        {
          "title": "Ihinduka",
          "text": "Ijyana n’imiterere itandukanye y’amatsinda"
        },
        {
          "title": "Yizewe",
          "text": "Yubakiwe ibikorwa by’imari bya buri munsi"
        }
      ],
      "points": [
        {
          "title": "Gukurikirana Imari Ahantu Hamwe",
          "text": "Bika inyandiko zose ahantu hamwe kandi ugabanye impapuro."
        },
        {
          "title": "Kubazwa Inshingano mu Banyamuryango",
          "text": "Kurikirana ibikorwa by’abanyamuryango kandi wongere icyizere binyuze mu nyandiko zisobanutse."
        },
        {
          "title": "Raporo Zifasha Gufata Ibyemezo",
          "text": "Bona amakuru afasha mu gufata ibyemezo no gutegura neza."
        }
      ]
    },
    "features": {
      "title": "Ibiranga Sisitemu",
      "subtitle": "Ibyose bikenewe mu koroshya kwizigamira, inguzanyo no gukurikirana imari.",
      "items": [
        {
          "title": "Gucunga Imisanzu",
          "description": "Kurikirana imisanzu, ibyo abanyamuryango biyemeje, amateka y’ubwishyu, amafaranga asigaye n’imisanzu itatanzwe neza."
        },
        {
          "title": "Gucunga Inguzanyo",
          "description": "Cunga ubusabe bw’inguzanyo, kwemeza, gutanga, gahunda yo kwishyura n’amafaranga asigaye."
        },
        {
          "title": "Gukurikirana Inyungu",
          "description": "Kurikirana inyungu kandi utegure uburyo bwo kuzigabana mu mucyo."
        },
        {
          "title": "Gucunga Ibihano",
          "description": "Andika amafaranga yarengeje igihe, imisanzu itatanzwe n’ibihano mu buryo buteguye."
        },
        {
          "title": "Inyandiko z’Abanyamuryango n’Abagenerwabikorwa",
          "description": "Bika imyirondoro, abagenerwabikorwa, ibyo biyemeje n’amateka y’ibikorwa."
        },
        {
          "title": "Raporo na Dashibodi",
          "description": "Reba incamake, ukurikirane impinduka kandi ukore raporo z’imari zifasha abayobozi."
        }
      ]
    },
    "steps": {
      "title": "Uko Ikora",
      "subtitle": "Intambwe zoroshye kuva ku gutangira kugeza ku gufata ibyemezo byiza by’imari.",
      "items": [
        {
          "title": "Andikisha Abanyamuryango",
          "description": "Kora imyirondoro, shyiraho ibyo biyemeje kandi utegure abagenerwabikorwa n’inshingano."
        },
        {
          "title": "Kurikirana Ibikorwa by’Imari",
          "description": "Andika imisanzu, tanga inguzanyo, andika ubwishyu, inyungu n’ibihano."
        },
        {
          "title": "Suzuma Raporo",
          "description": "Koresha dashibodi na raporo mu gukurikirana imikorere no kongera gukorera mu mucyo."
        }
      ]
    },
    "benefits": {
      "title": "Kuki Wahitamo Iyi Sisitemu?",
      "subtitle": "Yubakiwe kugabanya imirimo ikorwa n’intoki no kongera icyizere mu micungire y’imari.",
      "items": [
        {
          "title": "Gukorera mu Mucyo",
          "description": "Buri gikorwa cy’imari cyandikwa neza kugira ngo kibazwe."
        },
        {
          "title": "Kugabanya Imirimo y’Intoki",
          "description": "Gabanya impapuro n’imibare isubirwamo."
        },
        {
          "title": "Gufata Ibyemezo Byiza",
          "description": "Koresha raporo zisobanutse n’isesengura mu kuyobora itsinda."
        },
        {
          "title": "Imikorere y’Umwuga",
          "description": "Garagaza imikorere iteguye kandi yizewe ku banyamuryango."
        }
      ]
    },
    "testimonials": {
      "title": "Ibyo Imiryango Iha Agaciro",
      "subtitle": "Ingero z’agaciro uru rubuga rushobora kuzana.",
      "items": [
        {
          "name": "Umubitsi w’Itsinda",
          "role": "Itsinda ryo Kwizigamira",
          "message": "Urubuga rudufasha kubika neza imisanzu n’ishyurwa ry’inguzanyo, kandi ibyo byongereye icyizere mu banyamuryango."
        },
        {
          "name": "Ushinzwe Ibikorwa",
          "role": "Koperative",
          "message": "Gukora raporo byabaye byoroshye kandi by’umwuga. Tubona vuba uko itsinda rihagaze tutagishingira ku bitabo by’intoki."
        },
        {
          "name": "Umuhuzabikorwa w’Ishyirahamwe",
          "role": "Ishyirahamwe ry’Abanyamuryango",
          "message": "Kugira imisanzu, ibihano n’inyandiko z’abanyamuryango muri sisitemu imwe byoroshya ubuyobozi kandi bikongera gukorera mu mucyo."
        }
      ]
    },
    "cta": {
      "title": "Mwiteguye Kuvugurura Imicungire y’Ubwizigame?",
      "subtitle": "Saba kwerekwamo sisitemu urebe uko yafasha itsinda cyangwa umuryango wawe.",
      "button": "Teganya Kwerekwa Sisitemu"
    },
    "demo": {
      "title": "Saba Kwerekwa Sisitemu",
      "subtitle": "Uzuza ifishi maze tukuvugishe kugira ngo dutegure igihe cyo kukwereka sisitemu.",
      "responseTime": "Dusubiza ubusabe bwo kwerekwamo sisitemu vuba bishoboka.",
      "points": [
        "Kukwereka sisitemu ku buryo bujyanye n’ibyo ukeneye",
        "Gusobanura ibiranga sisitemu ku muryango wawe",
        "Kukuyobora ku ishyirwa mu bikorwa no kuyikoresha"
      ],
      "form": {
        "fullName": "Amazina Yuzuye",
        "fullNamePlaceholder": "Andika amazina yawe yose",
        "organization": "Umuryango",
        "organizationPlaceholder": "Izina ry’umuryango",
        "email": "Imeyili",
        "emailPlaceholder": "wowe{'@'}example.com",
        "phone": "Nomero ya Telefoni",
        "phonePlaceholder": "+250...",
        "message": "Ubutumwa",
        "messagePlaceholder": "Tubwire iby’itsinda, koperative cyangwa umuryango wawe...",
        "submitting": "Birimo koherezwa...",
        "submit": "Ohereza Ubusabe"
      },
      "messages": {
        "success": "Ubusabe bwawe bwo kwerekwamo sisitemu bwoherejwe neza.",
        "validation": "Kosora ahagaragajwe amakosa.",
        "error": "Habaye ikibazo mu kohereza ubusabe bwawe."
      }
    },
    "faq": {
      "title": "Ibibazo Bikunze Kubazwa",
      "subtitle": "Ibisubizo ku bibazo bikunze kubazwa ku rubuga.",
      "items": [
        {
          "question": "Iyi sisitemu yagenewe nde?",
          "answer": "Yagenewe amatsinda yo kwizigamira, amakoperative, SACCO, amashyirahamwe, imiryango itegamiye kuri Leta n’indi miryango icunga imisanzu, inguzanyo n’ibikorwa by’imari by’abanyamuryango."
        },
        {
          "question": "Sisitemu ishobora gukurikirana inguzanyo n’ubwishyu?",
          "answer": "Yego. Ishobora gucunga inyandiko z’inguzanyo, gukurikirana ubwishyu n’amafaranga asigaye."
        },
        {
          "question": "Ifasha gukurikirana inyungu n’ibihano?",
          "answer": "Yego. Ushobora gukurikirana inyungu, ibihano, ubwishyu bwarengeje igihe n’ibindi bikorwa by’imari."
        },
        {
          "question": "Dushobora gusaba kwerekwamo sisitemu mbere yo kuyifata?",
          "answer": "Yego. Uru rupapuro rufite ifishi yo gusaba kwerekwamo sisitemu kugira ngo imiryango ibishaka iteganye igihe."
        },
        {
          "question": "Sisitemu ishobora guhindurwa ikajyana n’ibyo dukeneye?",
          "answer": "Yego. Bitewe n’ibyo mukeneye, ibiranga sisitemu n’imikorere yayo bishobora guhindurwa bikajyana n’itsinda cyangwa umuryango."
        }
      ]
    },
    "footer": {
      "description": "Urubuga rugezweho rufasha amatsinda yo kwizigamira, amakoperative n’imiryango gucunga imisanzu, inguzanyo, inyungu na raporo.",
      "quickLinks": "Aho Wihuta",
      "modules": "Ibice bya Sisitemu",
      "contact": "Twandikire",
      "contributions": "Imisanzu",
      "loans": "Inguzanyo",
      "profits": "Inyungu",
      "reports": "Raporo",
      "email": "Imeyili",
      "phone": "Telefoni",
      "location": "Aho Duherereye",
      "rights": "Uburenganzira bwose burabitswe.",
      "tagline": "Kurikirana imisanzu. Cunga inguzanyo. Mutere imbere hamwe."
    },
    "floatingCta": "Jya ku ifishi yo gusaba kwerekwamo sisitemu"
  }
};